import { render, staticRenderFns } from "./twoDimensional.vue?vue&type=template&id=4a1246d0&scoped=true"
import script from "./twoDimensional.vue?vue&type=script&lang=js"
export * from "./twoDimensional.vue?vue&type=script&lang=js"
import style0 from "./twoDimensional.vue?vue&type=style&index=0&id=4a1246d0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1246d0",
  null
  
)

export default component.exports